























































































































































































































































































































































































import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop, PropSync } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { List } from "linq-collections";
import { vuex } from "@/store";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
// component
// interfaces
import { CourseElementVm } from "@/interfaces/CourseElementVm";
import { courseElementTypeItems } from "@/interfaces/Types";
import { CourseElementType } from "@/interfaces/CourseElementType";
import { CustomTranslationType } from "@/interfaces/QuizOptionVm";
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { ParamUpdateElementTranslationVm } from "@/interfaces/ParamUpdateElementTranslationVm";
import { CustomizationVm } from "@/interfaces/CustomizationVm";

//const auth = namespace("auth");
const customization = namespace("customization");
const globals = namespace("globals");

@Component({
  components: {
  }
})
export default class CustomTranslationDlg extends Vue {
  @PropSync("showDialog") syncedShowDialog!: boolean;
  @Prop() element!: CourseElementVm;
  @customization.Getter customizationSettings!: CustomizationVm;
  @globals.Getter selectedExercise!: ExerciseVM;
  @globals.Getter selectedLanguageCode!: string | null;
  @globals.Action loadModulePages!: () => Promise<void>;
  @globals.Action setTranslationRequiredOnBundle!: (boolean) => Promise<void>;

  courseElementTypeItems = courseElementTypeItems;

  busyOnSave = false;

  // translateTextBusy = false;
  // translateAiSummaryBusy = false;
  // translateAltTextBusy = false;
  // translateTitleBusy = false;
  // translateLeftLabelBusy = false;
  // translateRightLabelBusy = false;
  // translateContentUrlBusy = false;
  // translateOptionBusy: Record<string, boolean> = {};

  // removeTextBusy = false;
  // removeAiSummaryBusy = false;
  // removeAltTextBusy = false;
  // removeTitleBusy = false;
  // removeLeftLabelBusy = false;
  // removeRightLabelBusy = false;
  // removeContentUrlBusy = false;
  // removeOptionBusy: Record<string, boolean> = {};

  editElement: CourseElementVm | null = null;

  // @auth.Getter isAdmin: any;
  // @auth.Getter isOrgAdmin: any;
  // @auth.Getter isGroupAdmin: any;

  // $refs!: {
  //   signatureComponent: any;
  // };

  mounted() {
  }

  @Watch("syncedShowDialog")
  async onShowDialogChanged(val: boolean) {
    if (this.syncedShowDialog) {
      // On dialog open
      await this.updateView();
      this.editElement = _.cloneDeep(this.element);

      // Disable body scroll on iOS
      this.$nextTick(async () => {
        await this.$globalHelper.delay(10);
        const modal = document.querySelector('.modal');
        disableBodyScroll(modal);
      });
    } else {
      // Dialog closing
      clearAllBodyScrollLocks();
    }
  }

  beforeDestroy() {
    clearAllBodyScrollLocks();
  }

  async updateView() {
  }

  async onRemoveCurrentTranslation(attributeName: string) {
    if (!this.editElement) return;

    if (attributeName === 'ContentUrl') {
      this.editElement.contentUrl = "zurücksetzen und vom Master übernommen";
      this.editElement.contentUrlCustomTranslation = CustomTranslationType.Master; // If set to master, the translation will be taken from the master on save
      return;
    }

    if (attributeName === 'Text') {
      this.editElement.text = "zurücksetzen und vom Master übernommen";
      this.editElement.textCustomTranslation = CustomTranslationType.Master;
      return;
    }

    // if (attributeName === 'AiSummary') {
    //   this.removeAiSummaryBusy = true;
    // }

    if (attributeName === 'AltText') {
      this.editElement.altText = "zurücksetzen und vom Master übernommen";
      this.editElement.altTextCustomTranslation = CustomTranslationType.Master;
      return;
    }

    if (attributeName === 'Title') {
      this.editElement.title = "zurücksetzen und vom Master übernommen";
      this.editElement.titleCustomTranslation = CustomTranslationType.Master;
      return;
    }

    if (attributeName === 'LeftLabel') {
      this.editElement.leftLabel = "zurücksetzen und vom Master übernommen";
      this.editElement.leftLabelCustomTranslation = CustomTranslationType.Master;
      return;
    }

    if (attributeName === 'RightLabel') {
      this.editElement.rightLabel = "zurücksetzen und vom Master übernommen";
      this.editElement.rightLabelCustomTranslation = CustomTranslationType.Master;
      return;
    }

    // If options of SingleChoice or MultipleChoice element, set option-specific busy flag before requesting
    let optionIndex = -1;
    if (attributeName.startsWith('Option')) {
      optionIndex = parseInt(attributeName.replace('Option', ''), 10);
      if (!isNaN(optionIndex) && this.editElement.options && this.editElement.options.length > optionIndex) {
        this.editElement.options[optionIndex].title = null;
        this.editElement.options[optionIndex].text = "zurücksetzen und vom Master übernommen";
        this.editElement.options[optionIndex].resolution = null;
        this.editElement.options[optionIndex].customTranslation = CustomTranslationType.Master;
      }
    }

    // let params: ParamDictionary = { dictionary: {}};
    // params.dictionary!["ExerciseId"] = this.selectedExercise.id!.toString();
    // params.dictionary!["ElementGuid"] = this.editElement.guid!;
    // params.dictionary!["LanguageCode"] = this.selectedLanguageCode ?? "de-DE";
    // params.dictionary!["AttributeName"] = attributeName;

    // let response = await rest.url("contentManager/resetElementTranslation").post(params);

    // if (attributeName === 'Text') {
    //   this.editElement.text = response;
    //   this.editElement.textCustomTranslation = CustomTranslationType.Master;
    //   this.removeTextBusy = false;
    // } else if (attributeName === 'AltText') {
    //   this.editElement.altText = response;
    //   this.editElement.altTextCustomTranslation = CustomTranslationType.Master;
    //   this.removeAltTextBusy = false;
    // } else if (attributeName === 'Title') {
    //   this.editElement.title = response;
    //   this.editElement.titleCustomTranslation = CustomTranslationType.Master;
    //   this.removeTitleBusy = false;
    // } else if (attributeName === 'LeftLabel') {
    //   this.editElement.leftLabel = response;
    //   this.editElement.leftLabelCustomTranslation = CustomTranslationType.Master;
    //   this.removeLeftLabelBusy = false;
    // } else if (attributeName === 'RightLabel') {
    //   this.editElement.rightLabel = response;
    //   this.editElement.rightLabelCustomTranslation = CustomTranslationType.Master;
    //   this.removeRightLabelBusy = false;
    // } else if (attributeName === 'ContentUrl') {
    //   this.editElement.contentUrl = response;
    //   this.editElement.contentUrlCustomTranslation = CustomTranslationType.Master;
    //   this.removeContentUrlBusy = false;
    // }
    // // If options of SingleChoice or MultipleChoice element, check for start with "Option" and get index
    // else if (attributeName.startsWith('Option')) {
    // let index = parseInt(attributeName.replace('Option', ''), 10);
    // if (!isNaN(index) && this.editElement.options && this.editElement.options.length > index) {
    //   this.editElement.options[index].text = response;
    //   this.editElement.options[index].customTranslation = CustomTranslationType.Master;
    //   this.$set(this.removeOptionBusy, index.toString(), false);
    //   }
    // }
  }


  // async onTranslate(attributeName: string) {
  //   if (!this.editElement) return;

  //   if (attributeName === 'ContentUrl') {
  //     this.translateContentUrlBusy = true;
  //   }

  //   if (attributeName === 'Text') {
  //     this.translateTextBusy = true;
  //   }

  //   // if (attributeName === 'AiSummary') {
  //   //   this.translateAiSummaryBusy = true;
  //   // }

  //   if (attributeName === 'AltText') {
  //     this.translateAltTextBusy = true;
  //   }

  //   if (attributeName === 'Title') {
  //     this.translateTitleBusy = true;
  //   }

  //   if (attributeName === 'LeftLabel') {
  //     this.translateLeftLabelBusy = true;
  //   }

  //   if (attributeName === 'RightLabel') {
  //     this.translateRightLabelBusy = true;
  //   }

  //   // If options of SingleChoice or MultipleChoice element, set option-specific busy flag before requesting
  //   let optionIndex = -1;
  //   if (attributeName.startsWith('Option')) {
  //     optionIndex = parseInt(attributeName.replace('Option', ''));
  //     if (!isNaN(optionIndex)) {
  //       this.$set(this.translateOptionBusy, optionIndex.toString(), true);
  //     }
  //   }

  //   let params: ParamDictionary = { dictionary: {}};
  //   params.dictionary!["ExerciseId"] = this.selectedExercise.id!.toString();
  //   params.dictionary!["ElementGuid"] = this.editElement.guid!;
  //   params.dictionary!["AttributeName"] = attributeName;
  //   params.dictionary!["LanguageCode"] = this.selectedLanguageCode ?? "de-DE";

  //   let response = await rest.url("contentManager/translateElement").post(params);

  //   if (attributeName === 'Text') {
  //     this.editElement.text = response;
  //     this.editElement.textCustomTranslation = CustomTranslationType.Master;
  //     this.translateTextBusy = false;
  //   // } else if (attributeName === 'AiSummary') {
  //   //   this.editElement.aiSummary = response;
  //   //   this.editElement.aiSummaryCustomTranslation = CustomTranslationType.Master;
  //   //   this.translateAiSummaryBusy = false;
  //   } else if (attributeName === 'AltText') {
  //     this.editElement.altText = response;
  //     this.editElement.altTextCustomTranslation = CustomTranslationType.Master;
  //     this.translateAltTextBusy = false;
  //   } else if (attributeName === 'Title') {
  //     this.editElement.title = response;
  //     this.editElement.titleCustomTranslation = CustomTranslationType.Master;
  //     this.translateTitleBusy = false;
  //   } else if (attributeName === 'LeftLabel') {
  //     this.editElement.leftLabel = response;
  //     this.editElement.leftLabelCustomTranslation = CustomTranslationType.Master;
  //     this.translateLeftLabelBusy = false;
  //   } else if (attributeName === 'RightLabel') {
  //     this.editElement.rightLabel = response;
  //     this.editElement.rightLabelCustomTranslation = CustomTranslationType.Master;
  //     this.translateRightLabelBusy = false;
  //   } else if (attributeName === 'ContentUrl') {
  //     this.editElement.contentUrl = response;
  //     this.editElement.contentUrlCustomTranslation = CustomTranslationType.Master;
  //     this.translateContentUrlBusy = false;
  //   }
  //   // If options of SingleChoice or MultipleChoice element, check for start with "Option" and get index
  //   else if (attributeName.startsWith('Option')) {
  //     let index = parseInt(attributeName.replace('Option', ''));
  //     if (!isNaN(index) && this.editElement.options && this.editElement.options.length > index) {
  //       this.editElement.options[index].text = response;
  //       this.editElement.options[index].customTranslation = CustomTranslationType.Master;
  //       this.$set(this.translateOptionBusy, index.toString(), false);
  //     }
  //   }
  // }

  onAcceptCurrentTranslation(attributeName: string): void {
    if (!this.editElement) return;

    if (attributeName === 'Text') {
      this.editElement.textCustomTranslation = CustomTranslationType.Custom;
    // } else if (attributeName === 'AiSummary') {
    //   this.editElement.aiSummaryCustomTranslation = CustomTranslationType.Custom;
    } else if (attributeName === 'AltText') {
      this.editElement.altTextCustomTranslation = CustomTranslationType.Custom;
    } else if (attributeName === 'Title') {
      this.editElement.titleCustomTranslation = CustomTranslationType.Custom;
    } else if (attributeName === 'LeftLabel') {
      this.editElement.leftLabelCustomTranslation = CustomTranslationType.Custom;
    } else if (attributeName === 'RightLabel') {
      this.editElement.rightLabelCustomTranslation = CustomTranslationType.Custom;
    } else if (attributeName === 'ContentUrl') {
      this.editElement.contentUrlCustomTranslation = CustomTranslationType.Custom;
    }
    // If options of SingleChoice or MultipleChoice element, check for start with "Option" and get index
    else if (attributeName.startsWith('Option')) {
      let index = parseInt(attributeName.replace('Option', ''));
      if (!isNaN(index) && this.editElement.options && this.editElement.options.length > index) {
        this.editElement.options[index].customTranslation = CustomTranslationType.Custom;
      }
    }
  }

  async onSave() {
    if (!this.editElement) return;

    this.busyOnSave = true;

    let params: ParamUpdateElementTranslationVm = {
      exerciseId: this.selectedExercise.id!,
      languageCode: this.selectedLanguageCode ?? "de-DE",
      element: this.editElement,
    };

    let response = await rest.url("contentManager/updateElementTranslation").post(params);
    this.busyOnSave = false;

    // Set selected bundle to translation required if needed
    if (response == true) {
      await this.setTranslationRequiredOnBundle(true);
    }

    await this.loadModulePages();
    this.syncedShowDialog = false;
  }

  get contentUrlFileName(): string {
    if (!this.editElement || !this.editElement.contentUrl) return "";
    return this.$globalHelper.extractFileName(this.editElement.contentUrl);
  }

  isMasterTranslation(customTranslation: CustomTranslationType): boolean {
    return customTranslation === CustomTranslationType.Master;
  }

  isCustomTranslation(customTranslation: CustomTranslationType): boolean {
    return customTranslation === CustomTranslationType.Custom;
  }

  isConflictTranslation(customTranslation: CustomTranslationType): boolean {
    return customTranslation === CustomTranslationType.Conflict;
  }

  get isMdTextElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.MdText];
  }

  get isTextElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.Text];
  }

  get isPdfElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.Pdf];
  }

  get isImageElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.Image];
  }

  get isAudioElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.Audio];
  }

  get isTtsAudioElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.TtsAudio];
  }

  get isTtsSpeakElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.TtsSpeak];
  }

  get isAudioPodcastElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.AudioPodcast];
  }

  get isVideoElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.Video];
  }

  get isSingleChoiceElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.SingleChoice];
  }

  get isMultipleChoiceElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.MultipleChoice];
  }

  get isSequentialListElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.SequentialList];
  }

  get isFlipCardListElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.FlipCardList];
  }

  get isSliderElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.Slider];
  }

  get isRatingElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.Rating];
  }

  get isCommentElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.Comment];
  }

  get isLinkElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.Link];
  }

  get isSignatureElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.Signature];
  }

  get isScormElement(): boolean {
    if (!this.editElement) return false;
    return this.editElement.type! === CourseElementType[CourseElementType.Scorm];
  }

  getElementTitle(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.label : '';
  }

  getElementIcon(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.icon : '';
  }

  get disableSaveButton() {
    return false;
  }

  onCancel() {
    clearAllBodyScrollLocks();
    this.syncedShowDialog = false;
  }
}
